<script>
import { Tabs, Tab, List, Empty, Toast, Icon, Row, Col } from 'vant'
import BottomToolbar from '@/components/org/BottomToolbar'
import DateTimeFunc from '@/tbs/util/DateTimeFunc'
import { QNImageUtil, AppType } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-schedule-manage',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-tabs': Tabs,
        'van-tab': Tab,
        'van-list': List,
        'van-empty': Empty,
        'van-icon': Icon,
        'van-row': Row,
        'van-col': Col,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            schedule: {
                id: null,
                matchId: null,
                roundCount: null,
                roundTotal: null,
                rounds: null,
            },
            role: {
                isManager: null,
                isReferee: null,
            },
            selectedTabIndex: null,
            roundSeq: null,
            eventList: [],
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        isEventListEmtpy() {
            return this.eventList && (this.eventList.length == 0)
        },
        editRoundNum() {
            const roundCount = this.schedule.roundCount || 0
            if (this.locale.localeProp) {
                return this.locale.localeProp('edit-round-num', {
                    num: roundCount.toString()
                })
            }
            else {
                return ''
            }
        },
        totalRoundNum() {
            const roundTotal = this.schedule.roundTotal
            if (this.locale.localeProp) {
                return this.locale.localeProp('total-round-num', {
                    num: roundTotal
                })
            }
            else {
                return ''
            }
        },
        operatorIconButtons() {
            return [
                { type: 'create-activity', icon: 'icon-activity', label: this.locale['create-activity'] },
                { type: 'create-game', icon: 'add', label: this.locale['create-match'] },
            ]
        }
    },

    //--------------------------------------------------
    // component watch
    //--------------------------------------------------
    watch: {
        selectedTabIndex(value) {
            this.onRoundTabClick(value)
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onRoundTabClick(index) {
            console.log('onRoundTabClick', index)
            if (index == null || isNaN(index)) {
                index = 0
            }
            console.log('@index', index)
            if (this.selectedTabIndex != index) {
                this.selectedTabIndex = index
            }
            const roundItem = this.schedule.rounds[index]
            this.roundSeq = roundItem.index.toString()
            console.log('@roundSeq', roundItem.index.toString())
            this.$emit('custom-event', {
                type: 'load',
                data: {
                    matchGroupId: this.schedule.id,
                    roundSeq: roundItem.index,
                    round: roundItem.round,
                    stageId: roundItem.stageId
                }
            })
            // @tmp @dirty Try to fix the page offset after reloading on iOS.
            if (AppType.isInIOS()) {
                setTimeout(function() {
                    window.scrollTo(0, 0);
                    document.body.scrollTop = 0;
                }, 200)
            }
        },
        onRoundRateBtnClick() {
            if (!this.validateManager()) {
                return
            }
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditMatchRule',
                    params: {
                        id: this.schedule.id
                    },
                    query: {
                        matchId: this.schedule.matchId
                    }
                }
            })
        },
        onBottomToolbarIconClick(type) {
            console.log('onBottomToolbarIconClick', type)
            if (type == 'create-activity') {
                this.onCreateActivityBtnClick()
            }
            else if (type == 'create-game') {
                this.onCreateGameBtnClick()
            }
        },
        onCreateGameBtnClick() {
            console.log('onCreateGameBtnClick')
            if (!this.validateManager()) {
                return
            }
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgCreateGame',
                    query: {
                        matchGroupId: this.schedule.id,
                        roundSeq: this.roundSeq,
                        // roundTotal: this.schedule.roundTotal,
                        // stageId: this.schedule.rounds[0].stageId
                    }
                }
            })
        },
        onCreateActivityBtnClick() {
            console.log('onCreateActivityBtnClick')
            if (!this.validateManager()) {
                return
            }
            Toast(this.locale['coming-soon'])
        },
        onEditGameBtnClick(id) {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgManageGame',
                    params: {
                        id: id
                    },
                    query: {
                        tab: 0,
                        matchGroupId: this.schedule.id
                    }
                }
            })
        },
        onRefereeAllocBtnClick(id) {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgManageGame',
                    params: {
                        id: id
                    },
                    query: {
                        tab: 1,
                        matchGroupId: this.schedule.id
                    }
                }
            })
        },
        onLiveSettingBtnClick(id) {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgManageGame',
                    params: {
                        id: id
                    },
                    query: {
                        tab: 2,
                        matchGroupId: this.schedule.id
                    }
                }
            })
        },
        onRecordScoreBtnClick(id) {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgManageGame',
                    params: {
                        id: id
                    },
                    query: {
                        tab: 3,
                        matchGroupId: this.schedule.id,
                    }
                }
            })
        },
        onGameConfirmBtnClick(id) {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgManageGame',
                    params: {
                        id: id
                    },
                    query: {
                        tab: 5,
                        matchGroupId: this.schedule.id,
                    }
                }
            })
        },
        onGameStatsBtnClick(id) {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgManageGame',
                    params: {
                        id: id
                    },
                    query: {
                        tab: 4,
                        matchGroupId: this.schedule.id,
                    }
                }
            })
        },
        onViewGameBtnClick(id) {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgManageGame',
                    params: {
                        id: id
                    },
                    query: {
                        tab: 0,
                        matchGroupId: this.schedule.id,
                    }
                }
            })
        },
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        isDateStarter(event) {
            const eventStartDateStr = DateTimeFunc.formatDate(event.startDateTime, 'yyyy-MM-dd')
            const prevEventStartDateStr = event.prevStartDateTime ? DateTimeFunc.formatDate(event.prevStartDateTime, 'yyyy-MM-dd') : ''
            return !(eventStartDateStr === prevEventStartDateStr)
        },
        dateField(startDateTime) {
            let dateStr = DateTimeFunc.formatDate(startDateTime, 'yyyy-MM-dd')
            const currentYear = (new Date).getFullYear()
            dateStr = dateStr.replace(currentYear + '-', '')
            return dateStr
        },
        weekDayField(startDateTime) {
            return this.locale.localeProp('weekday-' + startDateTime.getDay())
        },
        matchGameSeq(seq) {
            return this.locale.localeProp('match-game-seq', {seq: seq})
        },
        timeField(startDateTime) {
            return DateTimeFunc.formatDate(startDateTime, 'hh:mm')
        },
        statusField(status) {
            return this.locale.localeProp('game-status-' + status)
        },
        isGameStart(status) {
            return (status != '1')
        },
        groupNameField(groupName) {
            return groupName ? (groupName + this.locale.localeProp('group-unit')) : ''
        },
        hasRoundSeq(round) {
            if (round.isGroupRound) {
                return true
            }
            else if (round.type == this.locale.localeProp('league-game')) {
                return true
            }
            return false
        },
        validateManager() {
            console.log('validateManager', this.role.isManager)
            if (this.role.isManager) {
                return true
            }
            else {
                Toast(this.locale['no-permission'])
                return false
            }
        },
        homeTeamScoreField(event) {
            if (event.homeTeamPenaltyScore) {
                return Number(event.homeTeamScore) + Number(event.homeTeamPenaltyScore) + '(' + event.homeTeamPenaltyScore + ')'
            }
            else {
                return event.homeTeamScore
            }
        },
        awayTeamScoreField(event) {
            if (event.awayTeamPenaltyScore) {
                return Number(event.awayTeamScore) + Number(event.awayTeamPenaltyScore) + '(' + event.awayTeamPenaltyScore + ')'
            }
            else {
                return event.awayTeamScore
            }
        }
    },
}
</script>

<template>
    <div class="match-schedule-manage">
        <van-tabs
            v-model="selectedTabIndex"
            :ellipsis="false"
            animated swipeable sticky
            offset-top="43">
            <van-tab 
                v-for="round in schedule.rounds" 
                :key="round.index"
                title-inactive-color="#969799"
            >
                <template #title>
                    <div class="text-center">
                        <span class="block text-title">{{ round.seq }}</span>
                        <span class="block main-text">{{ round.type }}</span>
                        <span class="block minor-text minor-color">{{ round.gameCount }}</span>
                    </div>
                </template>
                <div v-if="!isEventListEmtpy" class="bg-white">
                    <van-list>
                        <div 
                            v-for="event in eventList" 
                            :key="event.id">
                            <div v-if="isDateStarter(event)" class="date-starter vertical-center u-inner-padding">
                                <span class="minor-text main-secondary-color r-outer-margin">{{ dateField(event.startDateTime) }}</span>
                                <span class="minor-text main-secondary-color">{{ weekDayField(event.startDateTime) }}</span>
                            </div>
                            <div class="game-identifier-head vertical-center u-inner-padding">
                                <span class="minor-text main-secondary-color">{{ matchGameSeq(event.seq) }}</span>
                                <span class="minor-text l-outer-margin main-secondary-color">{{ round.type }}</span>
                                <span v-if="event.groupName" class="minor-text l-outer-margin main-secondary-color">{{ groupNameField(event.groupName) }}</span>
                                <span v-if="hasRoundSeq(round)" class="minor-text l-outer-margin main-secondary-color">{{ round.seq }}</span>
                            </div>
                            <div class="game-info-body vertical-center">
                                <div class="time-section inline-block u-inner-padding">
                                    <span class="main-text main-secondary-color">{{ timeField(event.startDateTime) }}</span>
                                </div>
                                <div class="team-section inline-block">
                                    <div class="top-unit vertical-center">
                                        <span class="r-inner-margin">
                                            <img v-if="event.homeTeamLogoUrl" :src="adjustImageSize(event.homeTeamLogoUrl, 60, 60)" style="width: 30px; height: 30px;"/>
                                            <img v-else src="@/assets/org/logo-symbol.png" style="width: 30px; height: 30px;"/>
                                        </span>
                                        <span class="team-name main-text van-ellipsis">{{ event.homeTeamName }}</span>
                                        <span>
                                            <span v-if="event.homeTeamScore">{{ homeTeamScoreField(event) }}</span>
                                            <span v-else>{{ locale['no-data-placeholder'] }}</span>
                                        </span>
                                    </div>
                                    <div class="bottom-unit vertical-center">
                                        <span class="r-inner-margin">
                                            <img v-if="event.awayTeamLogoUrl" :src="adjustImageSize(event.awayTeamLogoUrl, 60, 60)" style="width: 30px; height: 30px;"/>
                                            <img v-else src="@/assets/org/logo-symbol.png" style="width: 30px; height: 30px;"/>
                                        </span>
                                        <span class="team-name main-text van-ellipsis">{{ event.awayTeamName }}</span>
                                        <span v-if="event.awayTeamScore">{{ awayTeamScoreField(event) }}</span>
                                        <span v-else>{{ locale['no-data-placeholder'] }}</span>
                                    </div>
                                </div>
                                <div class="status-section inline-block text-center relative">
                                    <div class="vertical-hairline"></div>
                                    <span class="minor-text minor-color">{{ statusField(event.status) }}</span>
                                </div>
                            </div>
                            <div class="operator-footer relative">
                                <div class="separator-line-top"/>
                                <div class="u-outer-padding">
                                    <div v-if="role.isManager">
                                        <van-row v-if="!isGameStart(event.status)" type="flex" justify="end">
                                            <van-col span="6" class="text-right"
                                                @click="onRefereeAllocBtnClick(event.id)"
                                            >
                                                <van-icon name="manager-o" />
                                                <span class="minor-text main-secondary-color l-inner-margin">{{ locale['referee-alloc'] }}</span>
                                            </van-col>
                                            <van-col span="6" class="text-right"
                                                @click="onLiveSettingBtnClick(event.id)"
                                            >
                                                <van-icon name="video-o" />
                                                <span class="minor-text main-secondary-color l-inner-margin">{{ locale['live-setting'] }}</span>
                                            </van-col>
                                            <van-col span="6" class="text-right"
                                                @click="onEditGameBtnClick(event.id)"
                                            >
                                                <van-icon name="edit" />
                                                <span class="minor-text main-secondary-color l-inner-margin">{{ locale['edit-game'] }}</span>
                                            </van-col>
                                        </van-row>
                                        <van-row v-else type="flex" justify="end">
                                            <van-col span="6" class="text-right"
                                                @click="onRecordScoreBtnClick(event.id)"
                                            >
                                                <van-icon name="records" />
                                                <span class="minor-text main-secondary-color l-inner-margin">{{ locale['record-score'] }}</span>
                                            </van-col>
                                            <van-col span="6" class="text-right"
                                                @click="onGameConfirmBtnClick(event.id)"
                                            >
                                                <van-icon name="completed" />
                                                <span class="minor-text main-secondary-color l-inner-margin">{{ locale['game-confirm'] }}</span>
                                            </van-col>
                                            <van-col span="6" class="text-right"
                                                @click="onEditGameBtnClick(event.id)"
                                            >
                                                <van-icon name="edit" />
                                                <span class="minor-text main-secondary-color l-inner-margin">{{ locale['edit-game'] }}</span>
                                            </van-col>
                                        </van-row>
                                    </div>
                                    <div v-else>
                                        <van-row type="flex" justify="end">
                                            <van-col span="6" class="text-right"
                                                @click="onRecordScoreBtnClick(event.id)"
                                            >
                                                <van-icon name="records" />
                                                <span class="minor-text main-secondary-color l-inner-margin">{{ locale['record-score'] }}</span>
                                            </van-col>
                                            <van-col span="6" class="text-right"
                                                @click="onGameStatsBtnClick(event.id)"
                                            >
                                                <van-icon name="completed" />
                                                <span class="minor-text main-secondary-color l-inner-margin">{{ locale['game-stats'] }}</span>
                                            </van-col>
                                            <van-col span="6" class="text-right"
                                                @click="onViewGameBtnClick(event.id)"
                                            >
                                                <van-icon name="edit" />
                                                <span class="minor-text main-secondary-color l-inner-margin">{{ locale['view-game'] }}</span>
                                            </van-col>
                                        </van-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </van-list>
                </div>
                <div v-else @click="onCreateGameBtnClick">
                    <van-empty 
                        :description="locale['match-round-empty-hint']"
                        image="search"
                    />
                </div>
            </van-tab>
        </van-tabs>
        <bottom-toolbar
            type="rate-icons"
            :minorRateCountLabel="editRoundNum"
            :minorRateTotalLabel="totalRoundNum"
            :minorRateLink="true"
            :mainIcons="operatorIconButtons"
            @click-minor-rate="onRoundRateBtnClick"
            @click-main-icon="onBottomToolbarIconClick"
        />
    </div>
</template>

<style scoped>
.date-starter {
    height: 32px;
    background: #F1F5F9;
}
.game-identifier-head {
    height: 21px;
    background: linear-gradient(90deg, #FFEECD 2%, #FFFFFF 104%);
    width: 290px;
}
.game-info-body {
    height: 78px;
}
.time-section {
    width: 42px;
}
.team-section {
    width: 196px;
}
.team-name {
    width: 146px;
}
.top-unit {
    height: 30px;
    padding-top: 6px;
    padding-bottom: 3px;
}
.bottom-unit {
    padding-top: 3px;
    height: 30px;
}
.status-section {
    width: 104px;
}
.vertical-hairline {
	position: absolute;
	left: 0;
	top: -50%;
	width: 1px;
	height: 46px;
	border-right: 0.5px solid #ebedf0;
}
</style>